export default __webpack_public_path__ + "static/gatsby-2bca40cc57d76f4d599203be014f7494.png";